import React, { useEffect, useState } from "react";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useDispatch, useSelector, batch } from "react-redux";
import { isNonEmptyArray } from "../../../../../common/utils";
import { PortfolioSearchService } from "../../../../../api";
import { useApi } from "../../../../../common/hooks";
import { PortfolioTabPanel } from "./PortfolioTabPanel";
import style from "./PortfolioTabNavigation.module.css";
import SearchPortfolioContent from "../../../../search-portfolio/component/SearchPortfolioContent";
import { translate } from "../../../../../common/providers";
import {
	setCurrentTab,
	setFilters,
	setMyPortfolios,
	setProjectNameSearch,
	setSearch,
	setSorting,
} from "../slice/portfolio-space-slice";
import AddPortfolioProjectAction from "./AddPortfolioProjectAction";

const CERTIFICAT_PORTFOLIO = "Certificats";
const CONTRATS_PORTFOLIO = "Contrats";

export default function PortfolioTabNavigation({ search }) {
	const [selectedPage, setSelectedPage] = useState("");
	const [customPages, setCustomPages] = useState([]);
	const currentTab = useSelector(({ portfolioSpace }) => portfolioSpace?.currentTab);
	const userBUs = useSelector(({ context }) => context.companies);
	const { call: getMyPortfolios } = useApi(PortfolioSearchService.getMyPortfolios);
	const dispatch = useDispatch();
	useEffect(() => {
		getMyPortfolios()
			.then((data) => {
				if (isNonEmptyArray(data)) {
					let hasCertificat = false;
					let hasContract = false;
					if (isNonEmptyArray(userBUs)) {
						/** FIXED BU AND PORTFOLIO NAME FOR CERTIFICATS VEOLIA_DEV_IMPORTANT */
						if (userBUs.find((cp) => cp.companyName === CERTIFICAT_PORTFOLIO)) {
							hasCertificat = true;
						}
						if (
							isNonEmptyArray(
								userBUs?.filter(
									(company) =>
										company.companyName !== "VEOLIA EAU" &&
										company.companyName !== CONTRATS_PORTFOLIO &&
										company.companyName !== CERTIFICAT_PORTFOLIO
								)
							)
						) {
							hasContract = true;
						}
					}
					const portfolioAvailable = data.filter(
						(portfolio) =>
							(hasCertificat && portfolio.name === CERTIFICAT_PORTFOLIO) ||
							(hasContract && portfolio.name === CONTRATS_PORTFOLIO)
					);
					setCustomPages(portfolioAvailable);
					let tabToGoTo = portfolioAvailable?.[0];
					if (currentTab && portfolioAvailable.find((portfolio) => portfolio.id === currentTab.id)) {
						tabToGoTo = portfolioAvailable.find((portfolio) => portfolio.id === currentTab.id);
					}
					setSelectedPage(tabToGoTo);
					batch(() => {
						dispatch(setCurrentTab(tabToGoTo));
						dispatch(setMyPortfolios(portfolioAvailable));
					});
				}
			})
			.catch(console.error);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userBUs]);
	const handleChange = (event, newValue) => {
		setSelectedPage(newValue);
		batch(() => {
			dispatch(setCurrentTab(newValue));
			dispatch(setSearch({ uuidToValue: {} }));
			dispatch(setProjectNameSearch(""));
			dispatch(setFilters({ projectStatus: "ACTIVE" }));
			dispatch(setSorting({}));
		});
	};
	return (
		<div className={style.tabNavigationContainer}>
			{isNonEmptyArray(customPages) && (
				<TabContext value={selectedPage}>
					<div className={style.tabNavigationHeader}>
						<TabList
							aria-label="portfolio-tab-list-all-customer-pages"
							className={style.tabNavigationList}
							onChange={handleChange}
						>
							{customPages.map((page) => (
								<Tab
									className={style.tabNavigationLabel}
									label={translate(`common:portfolio-tab-navigation.${page?.name.toLowerCase()}`)}
									value={page}
								/>
							))}
						</TabList>
						<AddPortfolioProjectAction />
					</div>
					{customPages.map(
						(page) =>
							page.toString() === selectedPage.toString() && (
								<TabPanel key={page.id} className={style.tabNavigationPanel} value={page}>
									{search ? (
										<SearchPortfolioContent pagePortfolio={page} />
									) : (
										<PortfolioTabPanel page={page} />
									)}
								</TabPanel>
							)
					)}
				</TabContext>
			)}
		</div>
	);
}
